import React from 'react';
import styled from 'styled-components';

const PricingWrapper = styled.section`
  min-height: 60vh;
  padding: 2rem;
  background-color: #1a1a1a;
  color: white;
`;

const PricingGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
`;

const PlanCard = styled.div`
  background: #2e3244;
  padding: 2rem;
  max-width: 300px;
  border-radius: 8px;
  text-align: center;
`;

const PlanTitle = styled.h3`
  color: #3498db;
  margin-bottom: 1rem;
`;

const PlanPrice = styled.p`
  font-size: 2rem;
  margin: 1rem 0;
`;

const OrderButton = styled.button`
  background-color: #3498db;
  border: none;
  color: #fff;
  padding: 0.8rem 1.5rem;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #1d73c8;
  }
`;

function PricingPage() {
  return (
    <PricingWrapper>
      <h2 style={{ textAlign: 'center', color: '#3498db' }}>Our Pricing Plans</h2>
      <PricingGrid>
        <PlanCard>
          <PlanTitle>Basic</PlanTitle>
          <PlanPrice>$3.99/mo</PlanPrice>
          <p>1 Website, 10GB Storage, 100GB Bandwidth</p>
          <OrderButton onClick={() => window.location.href = '/order/basic'}>
            Order Now
          </OrderButton>
        </PlanCard>

        <PlanCard>
          <PlanTitle>Standard</PlanTitle>
          <PlanPrice>$6.99/mo</PlanPrice>
          <p>5 Websites, 50GB Storage, 500GB Bandwidth</p>
          <OrderButton onClick={() => window.location.href = '/order/standard'}>
            Order Now
          </OrderButton>
        </PlanCard>

        <PlanCard>
          <PlanTitle>Premium</PlanTitle>
          <PlanPrice>$9.99/mo</PlanPrice>
          <p>Unlimited Websites, 200GB Storage, Unmetered Bandwidth</p>
          <OrderButton onClick={() => window.location.href = '/order/premium'}>
            Order Now
          </OrderButton>
        </PlanCard>
      </PricingGrid>
    </PricingWrapper>
  );
}

export default PricingPage;
